import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Form } from "shards-react";
import Board from "../DragAndDropBoard/Board";
import BoardAlert from "../DragAndDropBoard/components/BoardAlert";
import { useRequestHook } from "../../utils/hooks/hooks";
import {
  addDocumentInRedux,
  updateAdditionalTabs,
} from "../../utils/redux/actions";
import ScrollElementTop from "../ScrollElementTop";

const DetectTypesToolbar = (props) => {
  const {
    setPageToDisplay,
    updateDocumentsList,
    mainModuleAdditionalFields,
    closeModal,
    dispatch,
    documentId,
    thumbnails,
    additionalFields,
    additionalTabs,
    pagesLength,
    alertMessage,
    setAlertMessage,
    saveHandler,
    showComment,
    sortByPage,
    diva,
  } = props;
  const { handleRequest } = useRequestHook(); //Define method to fetch data.
  const isMountedRef = useRef(null);
  const [formRef, setFormRef] = useState(null);

  const submitter = (e) => {
    // Save approved doc in DB
    e.preventDefault();
    const { value: refValue } = e.target.elements.reference;
    const recRefVal = e.target.elements.recognisedRef?.value ?? "";

    handleRequest(
      "post",
      "/thumbnails/update-thumbnails",
      {
        thumbnails,
        pagesLength,
        documentId,
        approved: true,
        reference: refValue,
        recognisedRef: recRefVal,
        additionalFields: additionalFieldsData(),
        divaTotalPages: diva?.divaTotalPages,
      },
      (response, msg) => {
        if (isMountedRef.current !== true) return;
        if (!response) {
          setAlertMessage({
            msg: msg ?? "Das Dokument kann nicht freigegeben werden!",
          });
          setTimeout(() => {
            window.location.reload();
            return;
          }, 2000);
        } else {
          updateDocumentsList((oldDocList) =>
            oldDocList.filter((document) => document.documentId !== documentId)
          );
          closeModal();
          return dispatch(addDocumentInRedux()); //empty the docment in redux
        }
      }
    );
  };

  const additionalFieldsData = () => {
    if (!additionalTabs || !additionalFields) return false;

    return additionalTabs.reduce(
      (obj, tabName) => ({ ...obj, [tabName]: additionalFields[tabName] }),
      {}
    );
  };

  const handleScrollEvent = ({ target }) =>
    target.scrollTop < 700
      ? formRef
        ? setFormRef(null)
        : null
      : formRef
      ? null
      : setFormRef(target);

  useEffect(() => {
    isMountedRef.current = true;

    if (thumbnails?.columnOrder) {
      const additionalFieldsTitles = Object.keys(mainModuleAdditionalFields);

      const newAdditionalTabs = thumbnails.columnOrder
        .filter((column) => {
          const { pageIds, title } = thumbnails.columns[column];
          return pageIds.length > 0 && additionalFieldsTitles.includes(title);
        })
        .map((column) => thumbnails.columns[column].title);

      dispatch(updateAdditionalTabs(newAdditionalTabs));
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [dispatch, mainModuleAdditionalFields, thumbnails]);

  return (
    <Form
      id="detect-types-form"
      className="h-100 d-flex position-relative"
      onSubmit={submitter}
    >
      <div
        className="overflow-auto w-100 d-flex"
        onScroll={(e) => handleScrollEvent(e)}
      >
        <Board
          setPageToDisplay={setPageToDisplay}
          saveHandler={saveHandler}
          showComment={showComment}
          sortByPage={sortByPage}
        />
      </div>
      <BoardAlert data={alertMessage} dismiss={() => setAlertMessage()} />
      {formRef && <ScrollElementTop element={formRef} />}
    </Form>
  );
};

const mapStateToProps = ({ savedDocument }) => {
  const {
    id: documentId,
    thumbnails,
    additionalFields,
    additionalTabs,
    pagesLength,
    diva,
  } = savedDocument;

  return {
    documentId,
    thumbnails,
    additionalFields,
    additionalTabs,
    pagesLength,
    diva,
  };
};

export default connect(mapStateToProps)(DetectTypesToolbar); //Export component and connect it with redux.
